
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppOptionsData } from './app-options.data';
import { ServicesData } from '../services/services.data';
import { AppOption } from './app-option';

@Component({
  selector: 'app-option-edit',
  templateUrl: './app-option-edit.tmpl.html'
})

export class AppOptionEdit implements OnInit {
  constructor(
    public router: Router,
    private activatedRoute: ActivatedRoute,
    public appOptionsData: AppOptionsData,
    private formBuilder: FormBuilder,
    public servicesData: ServicesData,
  ) {
  }

  appOption: AppOption;
  id: number;
  contactId: number;
  appOptionForm: FormGroup;

  public load(): void {
    this.appOptionsData.getEdit(this.id || 0)
      .subscribe((c: any) => {
        this.appOption = c;
        this.appOptionForm.patchValue(c);
      });
  }

  private initForm() {
    this.appOptionForm = this.formBuilder.group({
      createBy: [], createDate: [], changeBy: [], changeDate: [],
      appOptionID: [this.id, Validators.required],
      testMode: [false, Validators.required],
      canChargeMinusAmount: [false, Validators.required],
      autoChargePlansPayments: [false, Validators.required],
      readingOnlyLastNameToPhone: [false, Validators.required],
      withContactVoiceName: [false, Validators.required],
      iziCountIsSandboxMode: [false, Validators.required],
      iziCountSendCopy: [false, Validators.required],
      iziCountApiKey: [],
      iziCountSenderEmail: [],
      addressFormat: [],
      defaultIlTermID: [],
      defaultUsaTermID: [],
      defaultAccountLocation: [],
      defaultCurrency: [],
      defaultDonationCategory: [],
      defaultLanguage: [],
      defaultAffiliation: [],
      defaultCommitmentSubject: [],
      defaultDonationType: [],
      defaultLocationType: [],
      defaultForPost: [true]
    });
  }


  ngOnInit() {
    this.activatedRoute.params.forEach((params: Params) => {
      this.id = +params['appOptionID'];
    });
    this.initForm();
    this.load();
  }
}



